import { css } from '@emotion/react';
import { black, white } from 'styles';
import { typography } from 'styles/font';

/**
 * 품절 상품 카드 딤드
 * @description
 * 타깃 element에 .soldout 추가
 */
export const soldout_dimmed = css`
  position: relative;

  &.soldout {
    ::before {
      content: '품절';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      color: ${white};
      z-index: 1;
      ${typography.title5_bold}

      display: flex;
      justify-content: center;
      align-items: center;
    }
    ::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0.6;
      background: ${black};
      border-radius: 2px;
    }
  }
`;
